import goals from "../../../../src/components/content/goals/m5";
import * as React from 'react';
export default {
  goals,
  React
};